import ModalChangeProgramStatus from "./ModalChangeProgramStatus";

export default ModalChangeProgramStatus;